import MapWrapper from './map-wrapper';

export async function generateStaticParams() {
  return [{ id: 'placeholder' }];
}

export default function PhotoMapPage({ params }: { params: { id: string } }) {
  return <MapWrapper eventId={params.id} />;
}
